
interface EnvType {
    REACT_APP_BASE_LIFF: string;
}

const env = process.env as unknown as EnvType;
const baseUrlLiff = env.REACT_APP_BASE_LIFF;

export default baseUrlLiff;